
define('ldsh!modules/products/activation/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {
__p += '<div class="row voffset8">\n  <div class="col-md-10 col-md-offset-1">\n    <div id="activation">\n      ';
 if (model.isRequest) {;
__p += '\n        <div id="activationSpiner" class="activationContent center response">\n          <i class="ri-loader-4-fill fa-spin" style="font-size: 120px;"></i>\n          <div class="text-message">\n            <span class="i18n size20" data-i18n="[html]PUBLIC.ACTIVATION.LBL_WAIT"></span>\n            ';
 if (serviceName==='mdirector' ) { ;
__p += '\n              <span class="size20">MDirector.</span>\n              ';
 } else if (serviceName==='landings' ) { ;
__p += '\n                <span class="size20">Landing Optimizer.</span>\n                ';
 } else if (serviceName==='automation' ) { ;
__p += '\n                  <span class="size20">Marketing Automation.</span>\n                  ';
 } ;
__p += '\n          </div>\n        </div>\n        ';
 } else { ;
__p += '\n\n          ';
 if (model.isError) {;
__p += '\n            <div id="activationError" class="activationContent center response">\n              <i class="naranja fa fa-exclamation-circle" style="font-size: 120px;"></i>\n              <div class="text-message">\n                <span class="i18n size20" data-i18n="[html]PUBLIC.ACTIVATION.LBL_ERROR"></span>\n              </div>\n              <div class="text-message">\n                <span class="i18n naranja size21" data-i18n="[html]PUBLIC.ACTIVATION.LBL_ERROR_' +
__e(model.status) +
'"\n                  id="errorMessage"></span>\n              </div>\n            </div>\n\n            ';
 } else{ ;
__p += '\n              <div id="activationSuccess" class="activationContent center response">\n                <i class="verde fa fa-check-circle-o" style="font-size: 120px;"></i>\n                <div class="text-message">\n                  <span class="i18n size20" data-i18n="[html]PUBLIC.ACTIVATION.LBL_SUCCESS"></span>\n                  <br />\n                  <span class="i18n size20" data-i18n="[html]PUBLIC.ACTIVATION.LBL_SUCCESS_TEXT1"></span>\n                  <span class="size20">' +
__e(serviceName) +
'.</span>\n                </div>\n              </div>\n              ';
 } ;
__p += '\n                ';
 } ;
__p += '\n    </div>\n  </div>\n</div>\n\n';
 if (isMdirector) {;
__p += '\n\n  <!-- SmartAdserver Tracking Begin -->\n  <!-- Freemium Registro Completo -->\n  <!-- Tracking with script -->\n  <SCRIPT type="text/javascript">\n    sas_tmstp = Math.round(Math.random() * 10000000000);\n    if ($(\'#smartFreemiumRegistroCompleto\').length === 0) {\n      $(\'body\').append(\'<iframe id="smartFreemiumRegistroCompleto" src="//ww264.smartadserver.com/track/ift2.asp?183427;16474;\' + sas_tmstp + \';0;[transactionid];[reference]" width=1 height=1 iframeborder=0></iframe>\');\n    }\n  </SCRIPT>\n  <!-- SmartAdserver Tracking End -->\n\n  ';
 } ;


}
return __p
};});

